module.exports = __webpack_public_path__ + "img/bg.7ce639c7.jpg";